import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';
import listReturnState from '../js/listReturnState';

export default {
  async prepare() {
    const vars = {};
    vars.filters = {};
    const listRestore = this.vars && this.vars.listRestore;
    this.recipe.methods.push(await O.mPOST('communal/organisation-types', vars));
    this.recipe.methods.push(await O.mPOST('communal/divisions', vars));
    if (listRestore && listRestore.filters) {
      this.vars.selected_page = listRestore.selected_page || 1;
      this.recipe.methods.push(
        await O.mPOST('communal/organisations', {
          filters: {...listRestore.filters},
          page: listRestore.selected_page || 1,
          limit: 10,
        })
      );
    } else {
      this.recipe.methods.push(await O.mPOST('communal/organisations', vars));
    }
    this.recipe.methods.push(await O.mPOST('communal/div-branches', vars));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const listReturn = this.vars && this.vars.listRestore;
    // Build Table Head
    await this.buildTableHead(data);

    if (listReturn) {
      this.applyListReturnToDom(listReturn);
      delete this.vars.listRestore;
    }

    // Event delegation: content is copied by innerHTML later so in-DOM listeners are lost.
    // Attach one listener on document that handles our filter dropdowns in the live DOM.
    const handler = (e) => {
      if (!e.target || !e.target.matches || !e.target.matches('#companyBranchDD, #companyDD, #orgTypeDD')) return;
      const page = (window.thsTab && typeof window.thsTab.getOrgList === 'function' ? window.thsTab : null) ||
        (window.thsPage && typeof window.thsPage.getOrgList === 'function' ? window.thsPage : null);
      if (page) {
        page.getOrgList();
      }
    };
    if (this._orgFilterHandler) {
      document.removeEventListener('change', this._orgFilterHandler);
    }
    this._orgFilterHandler = handler;
    document.addEventListener('change', this._orgFilterHandler);

    // Build Table Body
    const listData = data[`communal/organisations`];
    const orgListData = listData.data;
    await this.buildTableBody(orgListData);

    // Set state to current page then call function responsible for building pagination
    const paginationState = listData.pagination;
    this.vars.selected_page = paginationState.current_page;
    this.buildPaginationButtons(paginationState);
  },

  async buildTableHead(data) {
    const companyDDdata = await data[`communal/divisions`].data.divisions;
    const orgTypeDDdata = await data[`communal/organisation-types`].data;
    const divBranchDData = await data[`communal/div-branches`].data;

    const tableHead = U.id('tableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    // ACTION (icons column - first)
    headRow.insertCell(0);

    const orgName = headRow.insertCell(1);
    orgName.innerHTML = 'Organisation Name';

    // DIVISION
    const company = headRow.insertCell(2);
    let companyDD = await comp.selectThead('companyDD', companyDDdata, 'division_uuid', 'division_text', 'thsPage.getOrgList()', 'Company');
    company.appendChild(companyDD);
    headRow.appendChild(company);

    // DIVISION BRANCH
    const companyBranch = headRow.insertCell(3);
    let companyBranchDD = await comp.selectThead('companyBranchDD', divBranchDData, 'division_branch_uuid', 'short_text', 'thsPage.getOrgList()', 'Company Branch');
    companyBranch.appendChild(companyBranchDD);
    headRow.appendChild(companyBranch);

    // ORGANISATION TYPE
    const orgType = headRow.insertCell(4);
    let orgTypeDD = await comp.selectThead('orgTypeDD', orgTypeDDdata, 'org_type_uuid', 'short_text', 'thsPage.getOrgList()', 'Organisation Type');
    orgType.appendChild(orgTypeDD);
    headRow.appendChild(orgType);

    // ROLE
    const reg_num = headRow.insertCell(5);
    reg_num.innerHTML = 'Registration Number';

    // AREA
    const area = headRow.insertCell(6);
    area.innerHTML = 'Province';
  },

  applyListReturnToDom(lr) {
    if (!lr || !lr.filters) return;
    const f = lr.filters;
    if (U.id('genSearch')) U.id('genSearch').value = f.search_filters != null ? f.search_filters : '';
    if (U.id('companyDD')) U.id('companyDD').value = f.company != null ? f.company : '';
    if (U.id('companyBranchDD')) U.id('companyBranchDD').value = f.companyBranch != null ? f.companyBranch : '';
    if (U.id('orgTypeDD')) U.id('orgTypeDD').value = f.orgType != null ? f.orgType : '';
  },

  captureListReturnState() {
    return {
      filters: {
        search_filters: U.id('genSearch') ? U.id('genSearch').value.trim() : '',
        company: U.id('companyDD') ? U.id('companyDD').value : '',
        companyBranch: U.id('companyBranchDD') ? U.id('companyBranchDD').value : '',
        orgType: U.id('orgTypeDD') ? U.id('orgTypeDD').value : '',
      },
      selected_page: this.vars.selected_page
        ? parseInt(String(this.vars.selected_page), 10) || 1
        : 1,
    };
  },

  async buildTableBody(listData) {
    const userListBody = U.id('tableBody');
    userListBody.innerHTML = '';

    if (listData.length) {
      for (const dataRow of listData) {
        const newRow = userListBody.insertRow();

        const editButton = newRow.insertCell(0);
        const linkSVG = svg.linkNewPage();
        linkSVG.style.cursor = 'pointer';
        linkSVG.setAttribute('role', 'button');
        linkSVG.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          listReturnState.save('ViewOrganisation', {
            listPage: 'ManageOrganisation',
            state: this.captureListReturnState(),
          });
          O.PREP('ViewOrganisation', `org_uuid=${dataRow.org_uuid}`);
        });
        editButton.appendChild(linkSVG);

        const row1 = newRow.insertCell(1);
        row1.innerHTML = dataRow.org_name;

        const company = newRow.insertCell(2);
        company.innerHTML = dataRow.division_text;

        const row3 = newRow.insertCell(3);
        row3.innerHTML = dataRow.division_branch_text;

        const row4 = newRow.insertCell(4);
        row4.innerHTML = dataRow.org_type_text;

        const row5 = newRow.insertCell(5);
        row5.innerHTML = dataRow.registration_num || '';

        const row6 = newRow.insertCell(6);
        row6.innerHTML = dataRow.province_text;
      }
    } else {
      const newRow = userListBody.insertRow();
      const empty = newRow.insertCell(0);
      empty.innerHTML = 'No organisations available.';
      empty.colSpan = 7;
    }
  },

  async buildPaginationButtons(paginationState) {
    // Render pagination button elements inside a pagination wrapper div
    await comp.paginationButtons({totalPages: paginationState.total_pages, wrapperID: 'orgPaginationWrapper'});
    // Once buttons are rendered then attach click event to each one
    const pageButtons = document.querySelectorAll('.pageButton');
    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Set the pagination payload to match newly selected page
        this.vars.selected_page = Number(e.target.getAttribute('value'));
        this.getOrgList();
      });
    });
  },

  async getOrgList() {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      const filters = {};
      // Reference values of select inputs and assign as a key to the filters object
      filters.search_filters = U.id('genSearch').value.trim();
      filters.company = U.id('companyDD').value;
      filters.companyBranch = U.id('companyBranchDD').value;
      filters.orgType = U.id('orgTypeDD').value;

      const vars = {};
      vars.filters = filters;
      vars.limit = 10;
      vars.page = parseInt(this.vars.selected_page);

      // Send both user-uuid and filters object to endpoint to get list of organisations that match filters
      O.PREP([await O.mPOST('communal/organisations', vars)])
        .then(async (res) => {
          const listData = res['communal/organisations'];
          const orgListData = listData.data;
          const paginationState = listData.pagination;

          // Render new table body and pagination buttons
          await this.buildTableBody(orgListData);
          this.buildPaginationButtons(paginationState);
        })
        .catch(() => {});
    }, 500);
  },

  async clearSearch() {
    const searchInps = document.querySelectorAll('.searchInputs');
    searchInps.forEach((inp) => {
      inp.value = '';
    });

    this.getOrgList();
  },
};
